const filterbox = document.getElementById('Filters');
const sortBox = document.getElementById('Sorts');
const currentPath = new URLSearchParams(window.location.search);
const rawQuery = window.location.search;
const filterBy = rawQuery.match(/filter=([^&]*)/);
const filterRaw = filterBy ? filterBy[1] : null;
const sortBy = currentPath.get('sortby');
function setSelect() {
    if (filterbox != null) {
        for (const option of filterbox.options) {
            if (filterRaw != null && option.value.includes(filterRaw)) {
                option.selected = true;
            }
        }
    }
}
function setSort() {
    if (sortBox != null) {
        for (const option of sortBox.options) {
            if (sortBy != null && option.value.includes(sortBy)) {
                option.selected = true;
            }
        }
    }
}
// Named event handler for change events
function handleChange() {
    const url = this.value;
    if (url) {
        window.location.href = url;
    }
}
if (filterbox != null) {
    setSelect();
    filterbox.addEventListener('change', handleChange);
}
if (sortBox != null) {
    setSort();
    sortBox.addEventListener('change', handleChange);
}
